"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _log = _interopRequireDefault(require("../shared/log"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/** Subscribes a socket to the ${domainName/state} event
 *
 * @returns the reconnect function, allowing to control wether or not the socket will try to
 * reconnect by removing the listener to the 'reconnect' event.
 */
function subscribe(_x, _x2, _x3) {
  return _subscribe.apply(this, arguments);
}

function _subscribe() {
  _subscribe = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(socket, domainName, listener) {
    var subscribeWithRetry, onReconnect;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            subscribeWithRetry = function subscribeWithRetry(resolve, reject) {
              var isRetry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              socket.emit('subscribe', {
                domain: domainName
              }, function (_ref) {
                var status = _ref.status,
                    state = _ref.state,
                    errCode = _ref.errCode,
                    errMessage = _ref.errMessage;

                if (status === 'OK') {
                  listener(state);
                  resolve();
                } else if (errCode === 'INVALID_DOMAIN' && !isRetry) {
                  setTimeout(function () {
                    subscribeWithRetry(resolve, reject, true);
                  }, 2000);
                } else {
                  reject(new Error(errMessage));
                }
              });
            };

            _context.prev = 1;
            _context.next = 4;
            return new Promise(subscribeWithRetry);

          case 4:
            _context.next = 9;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            throw _context.t0;

          case 9:
            socket.on("".concat(domainName, "/subscriptionError"), function (_ref2) {
              var errMessage = _ref2.errMessage;
              (0, _log["default"])("Subscription error: ".concat(errMessage));
            });
            socket.on("".concat(domainName, "/state"), listener);

            onReconnect = function onReconnect() {
              (0, _log["default"])("Reconnecting to domain ".concat(domainName));
              socket.emit('subscribe', {
                domain: domainName
              }, function (_ref3) {
                var state = _ref3.state,
                    errCode = _ref3.errCode;

                if (errCode) {
                  socket.removeListener("".concat(domainName, "/state"));
                  socket.removeListener("".concat(domainName, "/subscriptionError"));
                  socket.removeListener('connect', onReconnect);
                } else {
                  listener(state);
                }
              });
            };

            socket.on('connect', onReconnect);
            return _context.abrupt("return", onReconnect);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 6]]);
  }));
  return _subscribe.apply(this, arguments);
}

var _default = subscribe;
exports["default"] = _default;